import { render, staticRenderFns } from "./OwnerAccessCodes.vue?vue&type=template&id=40c5b010&"
import script from "./OwnerAccessCodes.vue?vue&type=script&lang=ts&"
export * from "./OwnerAccessCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports